/**
 * 测试环境
 */
// let defaultConfig = {
//         _PublicPath: `https://r2.qingwashipin.com/qingwa-b/`,
//         _PublicDist: 'qingwa-b',
//         _BaseUrl: 'https://issue-test.qingwashipin.com/',
//         _Bucket: 'q-res',
//         _HashUrl: 'issue-test',
//     }


/**
 * 开发环境
 * */

// let defaultConfig = {
//         _PublicPath: `https://r2-dev.qingwashipin.com/qingwa-b/`,
//         _PublicDist: 'qingwa-b',
//         _BaseUrl: 'https://issue-dev.qingwashipin.com/',
//         _Bucket: 'q-res-dev',
//         _BucketUrl: 'https://test-q-vod-resource-out.oss-cn-beijing.aliyuncs.com/'
// }
/**
 * 本地服务
 */
// let defaultConfig = {
//     _PublicPath : `https://r2.qingwashipin.com/qingwa-b/`,
//     _PublicDist : 'qingwa-b',
//     _BaseUrl : 'http://182.92.111.3:8180/',
//     _Bucket : 'q-res',
//     _HashUrl:'issue-test',
// }

/**
 * 正式环境
 */
let defaultConfig = {
    _PublicPath: `https://r2-online.qingwashipin.com/qingwa-b/`,
    _PublicDist: 'qingwa-b',
    _BaseUrl: 'https://issue.qingwashipin.com/',
    _Bucket: 'q-res-online',
    _HashUrl: 'issue',
}
module.exports = defaultConfig